import React from 'react';
import { Box } from '@material-ui/core';
import {
  CustomerRequestFooter,
  CustomerRequestList,
} from 'components/CustomerRequestList';
import { useWaiterTable } from '../../useWaiterTable';
import { getQueryByName } from 'helpers/query';
import { useLocation } from 'react-router-dom';

export function RequestProductList({ restaurantId, onDoRequest }) {
  const { products, updateProduct, removeProduct } = useWaiterTable();
  const { search } = useLocation();

  const handleDoRequest = async () => {
    if (!products.length) return;

    const tableId = getQueryByName(search, 'table');

    console.log(products);

    onDoRequest({
      restaurant_id: restaurantId,
      request_type_id: 1,
      table_id: tableId,
      request_products: products.map(({ id, ...product }) => ({
        ...product,
        note: product.cart.note,
        amount: product.cart.amount,
        product_id: id,
        product_options_request_products:
          product.cart.product_options_request_products,
      })),
    });
  };

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        minHeight: '100%',
      }}
    >
      <CustomerRequestFooter
        products={products}
        onDoRequest={handleDoRequest}
      />

      <CustomerRequestList
        products={products}
        onUpdateProductAmount={updateProduct}
        onRemoveProduct={removeProduct}
      />
    </Box>
  );
}
